module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"details":"Details","save":"Speichern","filledStock":"Vollgut"},"en":{"details":"Details","save":"Save","filledStock":"Filled Stock"}}')
  delete Component.options._Ctor
}
